export const linkedWorkflowsLabel = 'Linked journeys';
export const LINKED_WORKFLOWS_LABEL_TEST_ID = 'linked-workflows-label';
export const LINKED_WORKFLOWS_CONTENT_TEST_ID = 'linked-workflows-content';
